//viewMode context
export const planModeName = "plan";
export const infoModeName = "info";
export const arrangeModeName = "arrange";
export const insolationModeName = "insolation";
export const hotSpotModeName = "hotSpot";
export const editModeName = "edit";
export const stylesModeName = "styles";
export const isometricModeName = "isometric";

//status context
export const loadingStatusName = "loading";
export const errorStatusName = "error";
export const successStatusName = "success";